import {createContext} from "react";
import {DirectoryListItemProps} from "../Pages/XDrive/Components/DirectoryListItem";

const DirectoryItemContext = createContext<DirectoryListItemProps>({item: ""});

export default DirectoryItemContext;
